<template>
  <div class="submit-order">
    <div class="order-form-list" v-for="(item,index) in order_list">
      <div class="list-top">
        <div class="school-img"><img :src="imgUrl + item.img"></div>
        <div class="school-text">
          <div class="title">
            <span style="color: #403A3A;">{{ item.title }}</span>
          </div>
          <div class="sub_title">
            <span style="color: #ADADAF;">规格：{{ item.sku }}</span>
            <span style="color: #ADADAF;"></span>
          </div>
          <div class="money">
            <span class="money-of-sum">￥{{ item.price_yuan }}</span>
            <span style="color: #403A3A;">x{{ item.num }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-from">
      <div class="order-from-content">
        <van-field v-model="name" required :label="language_cut.student_name_label"
                   :placeholder="language_cut.student_name_placeholder"/>
        <div class="select-class">
          <i style="color: red; margin-left: -9px">*</i>
          <div>
            <div class="class">{{ language_cut.student_sex_label }}：</div>
            <div style="min-width:2rem;" @click="select_sex_popup = true">
              <span style="color: #323233;" v-if="select_sex">{{ select_sex }}</span>
              <span style="color: #969799;width:100%;"
                    v-else>{{ language_cut.student_sex_placeholder }}</span>
            </div>
          </div>
          <!-- <span @click="select_class_popup = true">></span> -->
          <van-popup position="bottom" :style="{ height: '40%', overflow: 'hidden' }" v-model="select_sex_popup">
            <van-picker :title="language_cut.student_sex_label" show-toolbar item-height="40px"
                        :columns="sexColumns" @confirm="onSexConfirm" @cancel="select_sex_popup = false"/>
          </van-popup>
        </div>
        <van-field v-model="phone" required :label="language_cut.student_phone_label"
                   :placeholder="language_cut.student_phone_placeholder" @focus="phone_focus"/>

        <div class="select-class">
          <i style="color: red; margin-left: -9px">*</i>
          <div>
            <div class="class">{{ language_cut.student_grade_label }}：</div>
            <div style="min-width:2rem;" @click="select_class_popup = true">
              <span style="color: #323233;" v-if="select_class">{{ select_class }}</span>
              <span style="color: #969799;width:100%;"
                    v-else>{{ language_cut.student_grade_placeholder }}</span>
            </div>
          </div>
          <!-- <span @click="select_class_popup = true">></span> -->
          <van-popup position="bottom" :style="{ height: '40%', overflow: 'hidden' }" v-model="select_class_popup">
            <van-picker :title="language_cut.student_grade_label" show-toolbar item-height="40px"
                        :columns="columns" @confirm="onConfirm" @cancel="select_class_popup = false"/>
          </van-popup>
        </div>
        <van-field v-model="banji" :label="language_cut.student_class_label"
                   :placeholder="language_cut.student_class_placeholder"/>
        <div class="select-class">
          <i style="color: red; margin-left: -9px">*</i>
          <div>
            <div class="class">{{ language_cut.collectionMethod_label }}：</div>
            <div style="min-width:2rem;" @click="select_collectionMethod_popup = true">
              <span style="color: #323233;" v-if="select_collectionMethod">{{ select_collectionMethod }}</span>
              <span style="color: #969799;width:100%;"
                    v-else>{{ language_cut.collectionMethod_placeholder }}</span>
            </div>
          </div>
          <!-- <span @click="select_class_popup = true">></span> -->
          <van-popup position="bottom" :style="{ height: '40%', overflow: 'hidden' }"
                     v-model="select_collectionMethod_popup">
            <van-picker :title="language_cut.collectionMethod_label" show-toolbar item-height="40px"
                        :columns="collectionMethodOption" @confirm="onConfirm2"
                        @cancel="select_collectionMethod_popup = false"/>
          </van-popup>
        </div>
        <div class="select-class" v-if="select_collectionMethod === '自提（Pick Up In The Store）'">
          <i style="color: red; margin-left: -9px">*</i>
          <div>
            <div class="class">{{ language_cut.collectionTime_label }}：</div>
            <div style="min-width:2rem;" @click="select_collectionTime_popup = true">
              <span style="color: #323233;" v-if="select_collectionTime">{{ select_collectionTime }}</span>
              <span style="color: #969799;width:100%;"
                    v-else>{{ language_cut.collectionTime_placeholder }}</span>
            </div>
          </div>
          <!-- <span @click="select_class_popup = true">></span> -->
          <van-popup position="bottom" :style="{ height: '40%', overflow: 'hidden' }"
                     v-model="select_collectionTime_popup">
            <van-picker :title="language_cut.collectionTime_label" show-toolbar item-height="40px"
                        :columns="columns1" @confirm="onConfirm1"
                        @cancel="select_collectionTime_popup = false"/>
          </van-popup>
        </div>
        <template v-if="select_collectionMethod === '快递（Express）—— 邮寄到付（freight at destination）'">
          <van-field v-model="shoujianren_name" required :label="language_cut.shoujianren_name_label"
                     :placeholder="language_cut.shoujianren_name_placeholder"/>
          <van-field v-model="shoujianren_phone" required :label="language_cut.shoujianren_phone_label"
                     :placeholder="language_cut.shoujianren_phone_placeholder"/>
          <van-field v-model="shoujianren_address" required :label="language_cut.shoujianren_address_label"
                     :placeholder="language_cut.shoujianren_address_placeholder"/>
        </template>
      </div>
    </div>
    <template v-if="select_collectionMethod === '自提（Pick Up In The Store）'">
      <div class="site">
        <div class="site-content">
          <div>{{ language_cut.draw_time }}：</div>
          <div v-for="item in pickUpGoodsTime">{{ item }}</div>
        </div>
        <div class="site-content" style="border: 0;">
          <div>{{ language_cut.draw_site }}：</div>
          <div v-for="item in pickUpGoodsAddress">{{ item }}</div>
        </div>
        <!--        <div class="remark">此商品需要您到校自提，请仔细确认地址！</div>-->
      </div>
      <div class="explain">
        <div class="title">{{ language_cut.draw_explain }}</div>
        <div v-for="item in pickUpGoodsRemarks">{{ item }}</div>
      </div>
    </template>
    <div class="bottom-pay-info">
      <div>
        <div class="money money-of-sum">{{ language_cut.total }}：￥{{ num_money }}</div>
      </div>
      <button class="pay-btn" @click="submit" v-if="click_submit">{{ language_cut.btn }}</button>
      <van-loading class="pay-btn" vertical type="spinner" v-if="!click_submit" color="#1989fa"/>
    </div>
    <van-popup v-model="pay_popup" closeable round position="bottom" :style="{ height: '5.5rem' }">
      <div class="pay-ok-popup" v-if="pay_status">
        <div class="title">{{ language_cut.pay_details }}</div>
        <van-icon name="checked"/>
        <div>{{ language_cut.pay_state }}</div>
        <button class="pay-ok-btn" @click="pay_ok_back">{{ language_cut.pay_btn }}</button>
      </div>
      <div class="pay-popup" v-else>
        <div class="title">{{ language_cut.pay_details }}</div>
        <div class="money"><span>￥</span>{{ pub_fun.centToYuan(orderForm.totalPrice) }}</div>
        <button class="pay-btn" @click="clickAliPay" v-if="!clickAliPayLoading">
          {{ language_cut.immediate_payment }}
        </button>
        <van-loading class="pay-btn" vertical type="spinner" v-if="clickAliPayLoading" color="#1989fa"/>
        <div class="remark">
          <van-icon name="alipay"/>
          {{ language_cut.Alipay_pay }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: this.$commonVariable.imgUrl,
      name: '',
      sex: '',
      phone: '',
      banji: '',
      shoujianren_address:'',
      shoujianren_name: '',
      shoujianren_phone: '',
      num_money: 0,
      pay_popup: false,     // 支付弹出层
      pay_status: false,      // 支付状态
      orderForm: {},   //提交订单后的订单号
      clickAliPayLoading: false,
      select_class: '',
      select_sex: '',
      select_collectionTime: '',
      // 领取方式
      select_collectionMethod: '',
      // select_collectionMethod: '自提（Pick Up In The Store）',

      click_submit: true,
      select_sex_popup: false,       // 选择班级弹出层
      select_class_popup: false,       // 选择班级弹出层
      select_collectionTime_popup: false,       // 选择班级弹出层
      // 选择领取方式弹出层
      select_collectionMethod_popup: false,

      // 班级数组
      columns: [],
      // 性别数组
      sexColumns: [],
      // 领取时间数组
      columns1: [],
      collectionMethodOption: ['自提（Pick Up In The Store）' , '快递（Express）—— 邮寄到付（freight at destination）'],
      // 领取方式数组
      // collectionMethodOption: ['自提（Pick Up In The Store）'],
      // columns: this.$commonVariable.haijia_class,      // 班级数组
      order_list: [],
      // 提货时间
      pickUpGoodsTime: [],
      // 自提地址
      pickUpGoodsAddress: [],
      // 自提说明
      pickUpGoodsRemarks: [],
      language_cut: {
        // 学生姓名
        student_name_label: 'name：',
        student_name_placeholder: 'please enter the student name',
        // 学生性别
        student_sex_label: 'sex',
        student_sex_placeholder: 'please enter the student sex',
        // 学生年级
        student_grade_label: 'grade：',
        student_grade_placeholder: 'please enter the student grade',
        // 学生班级
        student_class_label: 'class：',
        student_class_placeholder: 'please enter the student class',
        // 学生手机号
        student_phone_label: 'phone：',
        student_phone_placeholder: 'please enter the student phone',
        // 领取方式
        collectionMethod_label: 'Delivery Way',
        collectionMethod_placeholder: 'Please select Delivery Way',
        collectionMethodOption: ['Pick Up In The Store', 'Express'],
        // 领取时间
        collectionTime_label: 'collectionTime',
        collectionTime_placeholder: 'please enter the Collection time',
        // 收件人
        shoujianren_name_label: 'Recipient name',
        shoujianren_name_placeholder: 'please enter the Recipient name',
        shoujianren_phone_label: 'Recipient phone',
        shoujianren_phone_placeholder: 'please enter the Recipient phone',
        shoujianren_address_label: 'Recipient address',
        shoujianren_address_placeholder: 'please enter the Recipient address',
        draw_time: '领取时间',     // 领取时间
        draw_site: '',     // 领取地址
        draw_explain: '',      // 领取说明
        delivery_instructions: '',      // 快递说明
        delivery_instructions_detail: '',
        total: 'total',
        btn: '',
        pay_details: '',     // 付款详情
        pay_state: '',     // 付款状态
        pay_btn: '',     // 付款按钮
        immediate_payment: '',     // 立即付款
        Alipay_pay: '',     // 支付宝付款
      },
      payLink: '',
    }
  },
  created() {
    this.language_cut_fun();
    // 获取所有字典数据
    this.getDickList();
    if (this.$route.query.val) {
      let list = JSON.parse(sessionStorage.shopping_trolley_list)
      list.forEach((item, index) => {
        if (item.is_check == true) {
          this.order_list.push(item)
        }
      })
    } else {
      this.order_list = JSON.parse(sessionStorage.immediately_buy_list)
    }
    this.order_list.forEach((item, index) => {
      this.num_money += item.num * item.price
    })
    this.num_money = this.pub_fun.centToYuan(this.num_money)


  },
  methods: {
    clickAliPay() {
      if (!this.clickAliPayLoading) {
        this.clickAliPayLoading = true
        this.$service.aliPayPrepare({orderSn: this.orderForm.orderSn}).then(res => {
          this.clickAliPayLoading = false
          if (res.code === 20000) {
            window.location.href = res.data
          } else {
            this.$notify({type: 'danger', message: res.msg});
          }
        }).catch(() => {
          let msg = sessionStorage.language == 'ch' ? '请求异常' : 'Request exception'
          this.$notify({type: 'danger', message: msg});
        })
      }

    },
    language_cut_fun() {     // 语言切换
      if (sessionStorage.language == 'en') {
        this.language_cut = {
          // 学生姓名
          student_name_label: 'name：',
          student_name_placeholder: 'please enter the student name',
          // 学生性别
          student_sex_label: 'Gender',
          student_sex_placeholder: 'please enter the student Gender',
          // 学生年级
          student_grade_label: 'grade',
          student_grade_placeholder: 'Please select student grade',
          // 学生班级
          student_class_label: 'class：',
          student_class_placeholder: 'please enter the student class',
          // 学生手机号
          student_phone_label: 'Phone number：',
          student_phone_placeholder: 'please enter the Phone number',
          // 领取方式
          collectionMethod_label: 'Delivery Way',
          collectionMethod_placeholder: 'Please select Delivery Way',
          // 领取时间
          collectionTime_label: 'Pick up date',
          collectionTime_placeholder: 'Please select a Pick up date',
          // 收件人
          shoujianren_name_label: 'Recipient name',
          shoujianren_name_placeholder: 'please enter the Recipient name',
          shoujianren_phone_label: 'Recipient phone',
          shoujianren_phone_placeholder: 'please enter the Recipient phone',
          shoujianren_address_label: 'Recipient address',
          shoujianren_address_placeholder: 'please enter the Recipient address',
          draw_time: 'Pick up date',     // 领取时间
          draw_site: 'Pick up location',     // 领取地址
          draw_explain: 'draw explain',      // 领取说明
          delivery_instructions: 'Delivery Instructions',      // 快递说明
          delivery_instructions_detail: 'freight at destination',
          total: 'total',
          btn: 'submit',
          pay_details: 'pay details',     // 付款详情
          pay_state: 'payment success',     // 付款状态
          pay_btn: 'confirm',     // 付款按钮
          immediate_payment: 'immediate payment',     // 立即付款
          Alipay_pay: 'alipay pay',     // 支付宝付款
        }
      } else {
        this.language_cut = {
          // 学生姓名
          student_name_label: '学生姓名：',
          student_name_placeholder: '请输入学生姓名',
          // 学生性别
          student_sex_label: '学生性别',
          student_sex_placeholder: '请输入学生性别',
          // 学生年级
          student_grade_label: '学生年级',
          student_grade_placeholder: '请选择学生年级',
          // 学生班级
          student_class_label: '学生班级：',
          student_class_placeholder: '请输入学生班级',
          // 学生手机号
          student_phone_label: '手机号码：',
          student_phone_placeholder: '请输入手机号码',
          // 领取方式
          collectionMethod_label: '领取方式',
          collectionMethod_placeholder: '请选择领取方式',
          // 领取时间
          collectionTime_label: '领取日期',
          collectionTime_placeholder: '请选择领取日期',
          // 收件人
          shoujianren_name_label: '收件人',
          shoujianren_name_placeholder: '请输入收件人',
          shoujianren_phone_label: '收件人手机号',
          shoujianren_phone_placeholder: '请输入收件人手机号',
          shoujianren_address_label: '收件人地址',
          shoujianren_address_placeholder: '请输入收件人地址',
          draw_time: '领取时间',     // 领取时间
          draw_site: '领取地址',     // 领取地址
          draw_explain: '领取说明',      // 领取说明
          delivery_instructions: '快递说明',      // 快递说明
          delivery_instructions_detail: '邮寄到付',
          total: '合计',     // 合计
          btn: '提交订单',
          pay_details: '付款详情',     // 付款详情
          pay_state: '支付成功',     // 付款状态
          pay_btn: '确定',     // 付款按钮
          immediate_payment: '立即付款',     // 立即付款
          Alipay_pay: '支付宝付款',     // 支付宝付款
        }
      }
    },
    getDickList() {
      this.$service.getDictList().then(res => {
        if (res.code == 20000) {
          res.data.forEach(item => {
            let detail = item.detail.split(',')
            let details = []
            detail.forEach(item1 => {
              let arr = item1.split(':')
              details.push(arr[1])
            })
            if (item.name === '领取时间') {
              this.pickUpGoodsTime = details
            }
            if (item.name === '领取地址') {
              this.pickUpGoodsAddress = details
            }
            if (item.name === '自提说明') {
              this.pickUpGoodsRemarks = details
            }
            if (item.name === '年级') {
              this.columns = details
            }
            if (item.name === '性别') {
              this.sexColumns = details
            }
            if (item.name === '自提时间') {
              this.columns1 = details
            }
          })
        }
      })
    },
    pay_ok_back() {
      if (this.$route.query.val) {
        let list = JSON.parse(sessionStorage.shopping_trolley_list)
        this.order_list.forEach(item => {
          list.forEach((subItem, index) => {
            if (subItem.goodsId == item.goodsId && subItem.idSku == item.idSku && subItem.price == item.price && subItem.num == item.num) {
              list.splice(index, 1)
              sessionStorage.setItem('shopping_trolley_list', JSON.stringify(list))
              this.$router.push({
                path: '/list',
              })
            }
          })
        })
      } else {
        sessionStorage.removeItem('immediately_buy_list')
        this.$router.push({
          path: '/list',
        })
      }
    },
    call_submit_order() {
      this.$service.shopping_trolley_submit_order({
        idCarts: this.$route.query.idCarts
      }).then(res => {
        this.order_list = res.data.list
      })
    },
    submit() {
      if (!this.name) {
        let msg = sessionStorage.language == 'ch' ? '请输入学生姓名' : 'please enter the student name'
        this.$notify({type: 'danger', message: msg});
      } else if (!this.phone || !this.$commonVariable.phone_regular.test(this.phone)) {
        let msg = sessionStorage.language == 'ch' ? '手机号格式不正确' : 'Incorrect phone number format'
        this.$notify({type: 'danger', message: msg});
      } else if (!this.select_sex) {
        let msg = sessionStorage.language == 'ch' ? '请输入学生性别' : 'please enter the student sex'
        this.$notify({type: 'danger', message: msg});
      } else if (!this.select_class) {
        let msg = sessionStorage.language == 'ch' ? '请输入学生年级' : 'please enter the student grade'
        this.$notify({type: 'danger', message: msg});
      } else if (!this.select_collectionMethod) {
        let msg = sessionStorage.language == 'ch' ? '请选择领取方式' : 'Please select Delivery Way'
        this.$notify({type: 'danger', message: msg});
      } else {
        if (this.select_collectionMethod === '自提（Pick Up In The Store）') {
          if (!this.select_collectionTime) {
            let msg = sessionStorage.language == 'ch' ? '请选择领取时间' : 'Please select the collection time'
            this.$notify({type: 'danger', message: msg});
            return
          }
        }
        if (this.select_collectionMethod === '快递（Express）—— 邮寄到付（freight at destination）') {
          if (!this.shoujianren_name) {
            let msg = sessionStorage.language == 'ch' ? '请输入收件人姓名' : 'please enter the Recipient name'
            this.$notify({type: 'danger', message: msg});
            return
          }
          if (!this.shoujianren_phone || !this.$commonVariable.phone_regular.test(this.shoujianren_phone)) {
            let msg = sessionStorage.language == 'ch' ? '手机号格式不正确' : 'Incorrect phone number format'
            this.$notify({type: 'danger', message: msg});
            return
          }
          if (!this.shoujianren_address) {
            let msg = sessionStorage.language == 'ch' ? '请输入收件人地址' : 'please enter the Recipient address'
            this.$notify({type: 'danger', message: msg});
            return
          }
        }
        this.click_submit = false
        let ids = []
        let idSku = []
        let count = []
        this.order_list.forEach(item => {
          if (item.is_check == true) {
            ids.push(item.goodsId)
            idSku.push(item.idSku)
            count.push(item.num)
          }
        })
        ids = ids.join(',')
        idSku = idSku.join(',')
        count = count.join(',')
        sessionStorage.removeItem('Authorization')
        this.$service.immediately_buy({
          mobile: this.phone,
          passWord: '123123',
          smsCode: '123456',
          nickName: '',
        }).then(res => {
          sessionStorage.setItem('Authorization', res.data.token)
          for (let i = 0; i < this.order_list.length; i++) {
            this.$service.add_order({
              count: this.order_list[i].num,
              idGoods: this.order_list[i].goodsId,
              idSku: this.order_list[i].idSku,
            })
            if (i == this.order_list.length - 1) {
              let timeoutflag = ''
              timeoutflag = setTimeout(() => (
                  this.$service.cart_queryByUsers({}).then(ress => {
                    if (ress.status == 500) {
                      this.$notify({type: 'danger', message: '服务器错误'});
                      this.click_submit = true;     // 提交订单按钮loading
                    } else {
                      let idss = []
                      ress.data.forEach(item => {
                        idss.push(item.id)
                      })
                      idss = idss.join(',')

                      this.$service.save({
                        idCarts: idss,
                        classes: this.banji,     // 班级
                        grades: this.select_class,     // 年级
                        sex: this.select_sex,     // 性别
                        consignee: this.name,     // 收件人
                        mobile: this.phone,    // 手机号
                        collectionTime: this.select_collectionTime, //领取时间
                        idAddress: '',
                        receiveType: this.select_collectionMethod,
                        collectionName: this.shoujianren_name,
                        collectionPhoneNo: this.shoujianren_phone,
                        collectionAddre: this.shoujianren_address
                      }).then(res => {
                        this.click_submit = true;     // 提交订单按钮loading
                        if (res.code == 20000) {
                          this.orderForm = res.data
                          this.pay_status = false     // 支付成功
                          this.pay_popup = true     // 支付状态弹出层
                        } else {
                          this.$notify({type: 'danger', message: res.msg});
                        }
                      }).catch(() => {
                        this.click_submit = true;     // 提交订单按钮loading
                        this.$notify({type: 'danger', message: '服务器错误'});
                      })
                    }
                  })), 500)
            }
          }
        })
      }
    },
    onConfirm(value, index) {
      this.select_class_popup = false
      this.select_class = value
    },
    onSexConfirm(value, index) {
      this.select_sex_popup = false
      this.select_sex = value
    },
    onConfirm1(value, index) {
      this.select_collectionTime_popup = false
      this.select_collectionTime = value
    },
    onConfirm2(value, index) {
      if (value === '快递（Express）—— 邮寄到付（freight at destination）') {
        this.select_collectionTime = ''
      } else {
        this.shoujianren_name = ''
        this.shoujianren_phone = ''
        this.shoujianren_address = ''
      }
      this.select_collectionMethod_popup = false
      this.select_collectionMethod = value
    },
    phone_focus() {
      let msg = sessionStorage.language == 'ch' ? '查询订单重要凭证，请谨慎填写！' : 'Please fill in the important voucher carefully'
      this.$toast(msg);
    },
  },
}
</script>

<style lang="less">
.submit-order {
  padding-bottom: 1rem;

  .van-ellipsis {
    overflow: initial;
    white-space: inherit;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .order-form-list {
    margin-top: 0.2rem;
    width: 100%;
    // height: 2.65rem;
    box-sizing: border-box;
    background-color: #FFF;
    padding: 0.2rem 0.4rem 0 0.4rem;
    font-size: 0.25rem;

    .list-top {
      display: flex;
      padding-bottom: 0.2rem;
      border-bottom: 0.01rem solid #E2E2E2;

      .school-img {
        margin-right: 0.3rem;

        img {
          width: 1.6rem;
          height: 1.6rem;
        }
      }

      .school-text {
        width: 4.8rem;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;

        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .title {
          font-size: 0.3rem;
          color: #282423;
        }

        .sub_title {
          margin-top: 0.15rem;
        }

        .money {
          margin-top: 0.3rem;
        }
      }
    }

    .list-bottom {
      height: 0.7rem;
      box-sizing: border-box;
      line-height: 0.7rem;
      display: flex;
      justify-content: flex-end;
      color: #ADADAF;
      font-size: 0.2rem;
    }
  }

  .order-from {
    height: 100%;
    display: flex;
    justify-content: center;

    .order-from-content {
      width: 100%;
      margin-top: 0.2rem;
      background-color: #FFF;
      padding: 0 0 0 0.4rem;
      box-sizing: border-box;

      .van-field {
        border-bottom: 0.02rem solid #ECECEC;
      }

      .select-class {
        width: 100%;
        height: 0.9rem;
        box-sizing: border-box;
        padding: 10px 16px;
        color: #646566;
        font-size: 14px;
        border-bottom: 0.02rem solid #ECECEC;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          display: flex;
          width: 100%;
          box-sizing: border-box;

          > div {
            // width: 1.7rem;
            margin-right: 0.24rem;
          }

          .van-picker {
            width: 100%;
            margin-right: 0;
          }
        }

        .class {
          width: 6.2em;
          margin-right: 12px;
          color: #646566;
          text-align: left;
        }
      }
    }
  }

  .site {
    margin-top: 0.2rem;
    background-color: #FFF;
    color: #555354;
    font-size: 0.25rem;
    padding: 0 0 0.25rem 0.4rem;

    .site-content {
      padding-top: 0.2rem;
      border-bottom: 1px solid #E5E5E5;

      > div {
        margin-bottom: 0.2rem;
      }
    }

    .remark {
      margin-top: 0.4rem;
      color: #F31D0C;
      text-align: center;
      font-weight: bold;
    }
  }

  .explain {
    color: #909090;
    font-size: 0.22rem;
    padding: 0 0 0.3rem 0.4rem;

    .title {
      margin: 0.2rem 0;
      text-align: center;
    }

    > div {
      line-height: 1.8;
    }
  }

  .bottom-pay-info {
    position: fixed;
    bottom: 0rem;
    height: 1rem;
    width: 100%;
    z-index: 999;
    background-color: #FFF;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.15rem 0.4rem;
    // box-shadow:inset 0px -15px 10px -15px #b3afaf;

    > div {
      display: flex;
      align-items: center;

      .van-checkbox__label {
        padding-top: 0.05rem;
        font-size: 0.2rem;
        margin-left: 0.2rem;
      }

      > .money {
        font-size: 0.3rem;
        margin-left: 0.2rem;
      }
    }

    .pay-btn {
      font-size: 0.25rem;
      width: 2rem;
      height: 0.7rem;
      border-radius: 1rem;
      color: #FFF;
      background: linear-gradient(to right, #F08708 0%, #F9A908 100%);
    }

    .money-of-sum {
      color: #555454;
    }
  }

  .pay-popup {

    .title {
      margin: 0.35rem 0;
      color: #565355;
      text-align: center;
    }

    .money {
      font-size: 0.5rem;
      margin: 0.6rem 0;
      color: #595758;
      font-weight: bold;
      text-align: center;

      span {
        font-size: 0.35rem;
      }
    }

    .pay-btn {
      background-color: #02A9F0;
      border-radius: 1rem;
      color: #FFF;
      width: 6.8rem;
      height: 0.8rem;
      box-sizing: border-box;
      margin-left: 0.35rem;
    }

    .remark {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.27rem;
      margin-top: 0.3rem;

      i {
        font-size: 0.6rem;
        color: #02A9F0;
        margin-right: 0.1rem;
      }
    }
  }

  .pay-ok-popup {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #6E6C6D;

    .title {
      margin: 0.35rem 0;
      color: #565355;
      text-align: center;
    }

    i {
      color: #69BE7B;
      font-size: 2rem;
      margin: 0.3rem 0 0.1rem 0;
    }

    .pay-ok-btn {
      background-color: #02A9F0;
      border-radius: 1rem;
      color: #FFF;
      width: 6.8rem;
      height: 0.8rem;
      box-sizing: border-box;
      margin-top: 0.35rem;
    }
  }
}
</style>
